module.exports = __webpack_public_path__ + "static/media/3-solution-0.12fad875.mp3";